import './FilterMenu.css';

import * as React from 'react';

import FilterMenuOption from './FilterMenuOption';

export interface IFilterMenuOption {
  title: string;
}

export interface IFilterMenuProps {
  title: JSX.Element | string;
  options: IFilterMenuOption[];
  onFilter?(filterApplied: string): void;
  disabled?: boolean;
}

export interface IFilterMenuState {
  isOpen: boolean;
  isFiltered: boolean;
  selectedTitle: string;
}

const clearFilterText:string = "Clear Filter";
export default class FilterMenu extends React.Component<IFilterMenuProps, IFilterMenuState> {
  
  drop: HTMLElement;
  constructor(props: any) {
    super(props);

    this.state = {
      isOpen: false,
      isFiltered: false,
      selectedTitle: props.title,
    };
  }

  componentDidMount() {
    window.addEventListener('click', this.onClose, true);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onClose, true);
  }

  onClose = (e: any) => {
    const dropMenu = e.target.closest('.filtermenu');
    if (dropMenu !== this.drop) {
      this.setState({ isOpen: false });
    }
  }
  onToggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  }
  onFilter = (filterName: string) => {
    const clearFilter = (filterName == clearFilterText);
    if (clearFilter) {
      this.setState({ selectedTitle: this.props.title.toString(), isFiltered: false });
    } else {
      this.setState({ selectedTitle: filterName, isFiltered: true });
    }
    if (this.props.onFilter) {
      this.props.onFilter(clearFilter ? '' : filterName);
    }
  }

  render() {
    const { options, disabled } = this.props;
    const clearOption = [{title: clearFilterText}];
    const fullOptions = this.state.isFiltered ? clearOption.concat(options) : options;

    const isOpen = disabled ? false : this.state.isOpen;
    const className = `filtermenu ${disabled ? 'is-disabled' : ''}`;
    return (
      <div onClick={this.onToggle} className={className} ref={drop => this.drop = drop!}>        
        <div className="filtermenu-btn" onClick={e => e.nativeEvent.stopImmediatePropagation()}>
          <i className={`fas fa-filter`} />
        </div>
        <div className="filtermenuText">{this.state.selectedTitle}</div>

        {isOpen &&
          <div className="filtermenu-options-list">
            {fullOptions.map((o, i) => <FilterMenuOption key={o.title + i} {...o} onClick={ () => this.onFilter(o.title) }/>)}
          </div>
        }
      </ div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FilterMenu/FilterMenu.tsx